//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueParticlesGenerator from 'vue-particles-generator';

export default {
  name: 'PropsTable',
  computed: {
    props() {
      let result = [];

      for (let prop in VueParticlesGenerator.props) {
        result.push({
          key: prop,
          type: VueParticlesGenerator.props[prop].type.name,
          value: VueParticlesGenerator.props[prop].type.name === 'Array' ?
                  VueParticlesGenerator.props[prop].default() :
                  VueParticlesGenerator.props[prop].default
        })
      }

      return result;
    }
  }
}
